import * as actionTypes from 'src/actions';

const initialState = { subsidiaries: [], subsidiariesError: false };

const subsidiariesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_SUBSIDIARIES_SUCCESS: {
      return {
        ...state,
        subsidiaries: action.subsidiaries
      };
    }

    case actionTypes.ADD_SUBSIDIARIES_SUCCESS: {
      return {
        ...state,
        subsidiaries: [
          ...state.subsidiaries,
          {
            ...action.newSubsidiary
          }
        ]
      };
    }

    case actionTypes.EDIT_SUBSIDIARIES_SUCCESS: {
      return {
        ...state,
        subsidiaries: [
          ...state.subsidiaries.filter((subsidiary) => subsidiary.id !== action.subsidiary.id),
          action.subsidiary
        ]
      };
    }

    case actionTypes.SUBSIDIARIES_ERROR: {
      return {
        ...state,
        subsidiariesError: action.error
      };
    }

    default: {
      return state;
    }
  }
};

export default subsidiariesReducer;
